import React, { useState, useEffect } from 'react';
import './EmailFormIT.css';
import { offerClickBase } from '../../../constants';
import Loader from '../../../components/Loader/Loader';

const EmailFormIT = ({ picURL, pageType, campaignName, translations }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(null);

  const isValidEmail = (email) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email);
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    
    if (!isValidEmail(email)) {
      setError('Inserisci un indirizzo email valido');
      setSuccess(null);
      return;
    }

    setError(null);
    setSuccess(true);
    setLoading(true);

    // Store email in localStorage
    window.localStorage.setItem('S&R-IT', email);

    // Redirect after a delay
    setTimeout(() => {
      window.location.replace(`${offerClickBase()}&event1=${email}&sub4=it`);
    }, 700);
  };

  return (
    <div className="whole-form">
      <div>
        <div className="email-form-container">
          <form autoComplete="on" className="email-form">
            <label className="email-label" htmlFor="email">
              Inserisci il tuo indirizzo email{' '}
              <span className="not-success"></span>
            </label>
            <div>
              <input
                id="email-input"
                name="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <span className="not-success"></span>
              <br />
              {error && (
                <>
                  <small style={{ color: 'rgb(178, 34, 34)' }}>
                    {error}
                    <span className="not-success"></span>
                  </small>
                  <br />
                </>
              )}
            </div>
          </form>
        </div>
        <br />
        <div>
          {loading ? (
            <div className="loading-container">
              <Loader width="3em" height="3em" />
            </div>
          ) : success ? (
            <div className="success-message">Email verificata con successo!</div>
          ) : (
            <button 
              className="rewards-btn-getit" 
              style={{ opacity: 0.85 }}
              onClick={handleSubmit}
            >
              CONTINUA 👉
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailFormIT;
